import React from 'react';
import styles from '../../styles/CambioGrupoStyles/CambioGrupo.module.css';

function ConfirmationModal({ student, changeData, onConfirm, onCancel }) {
  return (
    <div className={styles.modalOverlay} onClick={onCancel}>
      <div className={styles.confirmationModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>Confirmación de Cambio</h3>
        </div>

        <div className={styles.modalContent}>
          <div className={styles.modalSection}>
            <h4 className={styles.sectionTitle}>Información del cambio</h4>
            <div className={styles.sectionDivider}></div>
            
            <div className={styles.infoGrid}>
              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>Estudiante:</span>
                <span className={styles.infoValue}>
                  {student.nombre} ({student.matricula})
                </span>
              </div>
              
              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>Materia:</span>
                <span className={styles.infoValue}>
                  {changeData.materia || 'Cálculo'}
                </span>
              </div>
              
              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>Grupo origen:</span>
                <span className={styles.infoValue}>
                  {changeData.grupoOrigen}
                </span>
              </div>
              
              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>Grupo destino:</span>
                <span className={styles.infoValue}>
                  {changeData.grupoDestino.split(' ')[0] || 'G-126'}
                </span>
              </div>
              
              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>Fecha de cambio:</span>
                <span className={styles.infoValue}>
                  {changeData.fechaCambio}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.modalActions}>
          <button 
            className={styles.cancelModalButton}
            onClick={onCancel}
          >
            CANCELAR
          </button>
          <button 
            className={styles.confirmModalButton}
            onClick={onConfirm}
          >
            CONFIRMAR
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;
